'use client'

import { Icon } from '@/components/ui'
import { useNudge } from '@/contexts/nudge'
import { useUserContext } from '@/contexts/user'
import Link from 'next/link'
import { useEffect, useState } from 'react'
import cx from 'classnames'

const Nudge = ({ className }: { className?: string }) => {
  const { isOpen, nudgeData, closeNudge } = useNudge()
  const { isLoginComplete } = useUserContext()
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  if (!isMounted || !isOpen || !isLoginComplete) {
    return null
  }

  return (
    <div
      className={cx(
        'bg-brand-50 z-[80] text-foreground-3 p-2 flex items-center text-xs rounded-[8px] w-full justify-between min-h-[34px] mb:absolute mb:top-1/2 mb:right-1/2 mb:translate-x-1/2 mb:-translate-y-1/2 mb:w-[calc(100vw_-_1rem)]',
        className
      )}
    >
      <Link href="/profile" className="flex-1 hover:underline">
        {nudgeData?.message}
      </Link>
      <button type="button" onClick={closeNudge} className="flex-none ml-2">
        <Icon name="interface/close" className="size-4" />
      </button>
    </div>
  )
}

export default Nudge
